import React from "react";
import { gql, useMutation } from "@apollo/client";

import { Checkbox, FormControl, FormControlLabel, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { CreditCard as CheckoutIcon } from "mdi-material-ui";

import OrderSidebar from "../index";

export default function DeferredPayment({ order }) {
  const [mutate, { loading: deferredPaymentLoading }] = useMutation(
    React.useMemo(
      () => gql`
        mutation ($orderId: ID!, $deferredPaymentAllowed: Boolean) {
          UpdateOrderAdmin(
            orderId: $orderId
            deferredPaymentAllowed: $deferredPaymentAllowed
          ) {
            order {
              id
              ...OrderSidebar_order
            }
          }
        }

        ${OrderSidebar.fragments.order}
      `,
      []
    )
  );

  const handleChange = React.useCallback(
    (event) =>
      mutate({
        variables: {
          orderId: order.id,
          deferredPaymentAllowed: event.target.checked,
        },
      }),
    [mutate, order.id]
  );

  const [stripeChargeCard, { loading: stripeChargeLoading }] = useMutation(
    React.useMemo(
      () => gql`
        mutation ($orderId: ID!) {
          OrderPaymentStripe_ChargeCardSetupIntent(orderId: $orderId) {
            order {
              id
            }
          }
        }
      `,
      []
    )
  );

  const handleChargeClick = React.useCallback(() => {
    stripeChargeCard({ variables: { orderId: order.id } });
  }, [stripeChargeCard, order.id]);

  if (order.paymentId) return null;

  return (
    <Stack spacing={1} direction="row">
      <FormControl sx={{ flexGrow: 1 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!order.deferredPaymentAllowed}
              onChange={handleChange}
              disabled={deferredPaymentLoading}
            />
          }
          label="Paiement différé autorisé"
        />
      </FormControl>

      {!!order.stripeCustomerId &&
        !!order.stripePaymentMethodId &&
        !!order.deferredPaymentAllowed && (
          <LoadingButton
            startIcon={<CheckoutIcon />}
            variant="text"
            fullWidth
            size="small"
            loading={stripeChargeLoading}
            disabled={deferredPaymentLoading}
            onClick={handleChargeClick}
          >
            Débiter
          </LoadingButton>
        )}
    </Stack>
  );
}

DeferredPayment.fragments = {
  order: gql`
    fragment OrderSidebar_Cart_DeferredPayment_order on Order {
      id
      paymentId
      deferredPaymentAllowed
      stripeCustomerId
      stripePaymentMethodId
    }
  `,
};
